<template>
  <div class="container">
    <cmp-header class="top-menu"></cmp-header>
    <div class="main">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }"
          >新闻聚焦</el-breadcrumb-item
        >
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <h2 style="margin:20px auto;text-align: center;">
          {{ detailData.title }}
        </h2>
        <div v-html="detailData.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import Qs from 'qs'
import { getNewsDetail } from '@/api/news'
export default {
  data() {
    return {
      id: this.$route.query.id,
      detailData: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const data = { id: this.id }
      // this.$http.post('/getNewsDetails', data).then(res => {
      //   this.detailData = res.data.data
      // })
      getNewsDetail(data)
        .then(res => {
          this.detailData = res.data
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  .top-menu {
    background: #013165 !important;
  }
  .main {
    width: 65%;
    margin: 80px auto;
  }
}
</style>
